import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ShieldOff } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Bloquea una ruta si el usuario no tiene la política requerida.
 * Muestra un mensaje amigable con opción de volver.
 * Si el usuario NO tiene NINGUNA política (loading), no redirige aún.
 */
export default function PolicyRoute({ policy, redirectTo, children }) {
  const { user, loading, policies, can } = useAuth();

  if (loading || (user && policies.length === 0)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="overline" data-testid="policy-loading">Verificando permisos…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (!can(policy)) {
    // Si se pidió redirect explícito, ir allá; sino mostrar acceso denegado
    if (redirectTo) return <Navigate to={redirectTo} replace />;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <div className="max-w-md text-center bg-card border rounded-md p-6" data-testid="access-denied">
          <ShieldOff className="w-10 h-10 mx-auto text-destructive mb-3" />
          <h2 className="text-lg font-bold mb-1">Acceso denegado</h2>
          <p className="text-sm text-muted-foreground mb-4">
            No tienes permisos para acceder a esta sección.
            Contacta al administrador si crees que esto es un error.
          </p>
          <p className="text-[10px] font-mono text-muted-foreground mb-4">
            Política requerida: <b>{policy}</b>
          </p>
          <Button onClick={() => window.history.back()} variant="outline" data-testid="access-denied-back">
            Volver
          </Button>
        </div>
      </div>
    );
  }
  return children;
}
